import React, { useState } from "react";
import { TextField, Button, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BG_MAIN from "../assets/bg-main.png";
import { ReactComponent as BNI_LOGO } from "../assets/BNI_logo.svg";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContextProvider";
import { useLoading } from "../context/LoadingContext";
import { encryptPassword } from "../utils/cryptoUtils";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [error, setError] = useState("");
  const { showLoading, hideLoading } = useLoading();
  const { login, isAuthenticated } = useAuth();
  const [apiError, setAPIError] = useState("");

  // const handleLogin = () => {
  //   // Navigate to a different page after login
  //   setEmailError(false);
  //   setPasswordError(false);
  //   if (email !== "UATUser@accenture.com") {
  //     setEmailError(true);
  //   }
  //   if (password !== "UATTest2") {
  //     setPasswordError(true);
  //   }
  //   if (email === "UATUser@accenture.com" && password === "UATTest2") {
  //     login({ email, userName: "UATUser" });
  //     navigate("/landing");
  //   }
  // };

  const handleLogin = async (e) => {
    e.preventDefault();
    setEmailError(false);
    setPasswordError(false);
    setAPIError("");
    
    let hasError = false;
    if (email === "") {
      setEmailError(true);
      hasError = true;
    }
    if (password === "") {
      setPasswordError(true); 
      hasError = true;
    }

    if (!hasError) {
      showLoading();
      const validCredentials = {
        email: email,
        password: encryptPassword(password)
      };

      try {
        const result = await login(validCredentials, navigate);
        if (!result.success) {
          setAPIError(result.error);
          setPasswordError(true);
          setEmailError(true);
        }
      } catch (err) {
        setError('An unexpected error occurred');
        setPasswordError(true);
        setEmailError(true);
      } finally {
        hideLoading();
      }
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
    setAPIError("");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setPasswordError(false);
    setAPIError("");
  };

  const isLoginDisabled = !email || !password;

  return (
    <div
      className="relative flex items-center justify-center h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${BG_MAIN})`,
      }}
    >
      {/* Top-left logo */}
      <div className="absolute top-4 left-4">
        
      </div>

      {/* Centered login box */}
      <div className="bg-white p-8 w-96 rounded-lg shadow-lg">
        <h2 className="text-lg text-center text-[#F15A23] font-semibold mb-6">
          Please login to continue
        </h2>
        <form className="flex flex-col gap-4 items-center">
          {/* Email Input with Icon */}
          <TextField
            label="Email"
            variant="outlined"
            size="small"
            type="email"
            value={email}
            onChange={handleEmailChange}
            fullWidth
            error={emailError}
            required
            sx={{ bgcolor: "white" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* Password Input with Icon */}
          <div className="w-full">
            <TextField
              label="Password"
              variant="outlined"
              size="small"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              fullWidth
              error={passwordError || !!apiError}
              required
              sx={{ bgcolor: "white" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
            />
            {apiError && (
              <div className="text-xs mt-1" style={{ color: 'red' }}>Either username or password is incorrect.</div>
            )}
          </div>

          {/* Login Button */}
          <Button
            variant="contained"
            color="primary"
            disabled={isLoginDisabled}
            onClick={handleLogin}
            sx={{
              width: "150px",
              borderRadius: "24px",
              height: "32px",
              backgroundColor: isLoginDisabled ? "#80a6a9" : "#00555C", // Lighter color for disabled
              "&:hover": {
                backgroundColor: isLoginDisabled ? "#80a6a9" : "#004649", // Slightly darker on hover
              },
            }}
          >
            Login
          </Button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
